<script>
import StorageService from '@/services/_app/storage/StorageService'
import moment from 'moment'

import { mapGetters } from 'vuex'
import { STORAGE_CUSTOMER_KEY } from '@/app/users/customer.store'

export default {
    name: 'AccountSelection',
    computed: {
        ...mapGetters('customer', {
            customers: 'getCustomers',
        }),
    },
    methods: {
        formatDate (date) {
            return moment(date).format('LL')
        },
		selectCustomer (customer) {
            StorageService.set(STORAGE_CUSTOMER_KEY, customer.id)
			window.location.href = this.$router.resolve({ name: 'frontend.overview' }).href
        },
    },
	mounted() {
		if (this.customers.length === 1) {
			this.$router.push({ name: 'frontend.overview' })
		}
	}
}

</script>

<template>
    <section class="account-selection-container">
        <div class="account-selection">
            <h1 class="account-selection-header">{{ $t('accountSelection.selectAccountTitle') }}</h1>
            <p class="account-selection-subtitle">{{ $t('accountSelection.selectAccountDesc') }}</p>
            <b class="account-selection-label">{{ $t('accountSelection.selectAccount') }}</b>
            <div class="account-selection-body">
                <div @click="selectCustomer(customer)" v-for="customer in customers" class="customer-card">
                    <div class="customer-header">
                        <div class="customer-name">
                            <b v-text="customer.name"/>
                            <label :class="{ 'active' : customer.active, 'inactive' : customer.inactive }">
                                {{ customer.active ? $t('accountSelection.active') : $t('accountSelection.inactive') }}
                            </label>
                        </div>
                        <p v-text="customer.domain"/>
                    </div>
                    <small v-text="$t('accountSelection.createdAt', { date: formatDate(customer.created.date) })"/>
                </div>
            </div>
        </div>
    </section>
</template>

<style scoped lang="scss">
h1 {
    font-size: 2rem;
    margin-bottom: 0;
    font-weight: 600;
}

b, label, small, p {
    margin: 0;
    padding: 0;
    font-size: 1.25rem;
}

.account-selection-container {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.account-selection {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.account-selection-label {
    margin-top: 3rem;
}

.account-selection-body {
    display: grid;
    gap: 3rem;

    @media (min-width: 1524px) {
        grid-template-columns: repeat(3, 1fr);
        min-width: 1024px;
    }
}

.customer-card {
    padding: 1.5rem;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    border-radius: 0.75rem;
    border: 1px solid #e5e7eb;
    cursor: pointer;

    p {
        color: #6b7280;
    }

    &:hover {
        border: 1px solid #367EF7;
    }
}

.customer-header {
    display: flex;
    flex-direction: column;
}

.customer-name {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6rem;

    label {
        font-size: 1rem;
        padding: 0.35rem 0.75rem;
        border-radius: 0.75rem;

        &.active {
            background-color: #dcfce7;
            border: 1px solid #4ade80;
            color: #16a34a;
        }

        &.inactive {
            background-color: #fef3c7;
            border: 1px solid #fbbf24;
            color: #b45309;
        }
    }
}

.customer-created {
    display: flex;
    gap: 0.5rem;
}

</style>
